import { render, staticRenderFns } from "./order-form-property-wig-type.vue?vue&type=template&id=cce103b2&scoped=true"
import script from "./order-form-property-wig-type.vue?vue&type=script&lang=js"
export * from "./order-form-property-wig-type.vue?vue&type=script&lang=js"
import style0 from "./order-form-property-wig-type.vue?vue&type=style&index=0&id=cce103b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce103b2",
  null
  
)

export default component.exports